import { render } from "./ModulesView.vue?vue&type=template&id=6aafd43b"
import script from "./ModulesView.vue?vue&type=script&lang=js"
export * from "./ModulesView.vue?vue&type=script&lang=js"

import "./ModulesView.vue?vue&type=style&index=0&id=6aafd43b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__